<div class="container rtc-evaluation-container">
  <div class="text-center my-5" *ngIf="isLoading">
    <app-spinner message="Cargando"></app-spinner>
  </div>
  <div class="col-sm-12" *ngIf="!isLoading">
    <form [formGroup]="evaluationForm">
      <div class="container-fluid">
        <!-- Si la evaluación fue enviada con éxito mostramos el mensaje grande en lugar de las preguntas -->
        <div
          *ngIf="showSubmitSuccess"
          #submissionSuccessContainer
          class="submission-success-full"
          role="status"
          aria-live="polite"
          tabindex="0"
        >
          <div class="submission-success-inner">
            <div class="submission-success-icon" aria-hidden="true">✓</div>
            <div class="submission-success-content">
              <div class="submission-success-title">Evaluación enviada</div>
              <div class="submission-success-subtitle">
                La evaluación para el vehículo
                <strong>{{ selectedOptions.licensePlate }}</strong> se ha
                enviado con éxito.
              </div>
            </div>
          </div>
        </div>
        <div *ngIf="!showSubmitSuccess" class="scrollable-questions">
          <div class="col-xs-12" formArrayName="questions">
            <div
              [ngClass]="{ 'not-Sync': isNotSynced(questionControl) }"
              class="row border rounded-2 p-2 my-1"
              id="question-{{ i }}"
              *ngFor="let questionControl of questionsControl; let i = index"
              [formGroupName]="i"
            >
              <div class="row">
                <div class="question-row">
                  <p class="question-text">
                    <span class="order"
                      >{{ questionControl.get("order")?.value }}.</span
                    >
                    {{ questionControl.get("question")?.value }}
                  </p>
                  <!-- icono de sincronización de pregunta movido dentro de los botones Sí/No -->
                </div>
              </div>
              <div class="row">
                <div
                  class="col-sm-2 text-center rounded mx-1 col-md-1"
                  (click)="selectRadio('yesAnswer-' + i)"
                >
                  <div class="pt-2">
                    <button
                      id="yesAnswer-{{ i }}"
                      type="button"
                      class="btn btn-sm w-100 btn-custom-border"
                      [ngClass]="
                        questionControl.get('answer')?.value === 'Si'
                          ? 'btn-primary active'
                          : 'btn-outline-primary'
                      "
                      [class.btn-sync-warning]="
                        questionControl.get('answer')?.value === 'Si' &&
                        questionControl.get('isSync')?.value === false
                      "
                      (click)="$event.stopPropagation(); setAnswer(i, 'Si')"
                      [attr.aria-pressed]="
                        questionControl.get('answer')?.value === 'Si'
                          ? 'true'
                          : 'false'
                      "
                      [disabled]="isSubmittingAnswer[i] === 'Si'"
                    >
                      <ng-container
                        *ngIf="isSubmittingAnswer[i] === 'Si'; else labelSi"
                      >
                        <span
                          class="spinner-border spinner-border-sm"
                          role="status"
                          aria-hidden="true"
                        ></span>
                      </ng-container>
                      <ng-template #labelSi>Sí</ng-template>
                      <!-- Icono/nota inline de sincronización dentro del botón Si -->
                      <span
                        class="inner-sync-icon"
                        *ngIf="
                          questionControl.get('answer')?.value === 'Si' &&
                          questionControl.get('isSync')?.value === false
                        "
                        (click)="$event.stopPropagation(); onSyncQuestion(i)"
                        (mouseenter)="
                          showGlobalTooltip(
                            $event,
                            getQuestionSyncTooltipMessage(questionControl)
                          )
                        "
                        (mouseleave)="hideGlobalTooltip()"
                        [attr.title]="
                          getQuestionSyncTooltipMessage(questionControl)
                        "
                        role="button"
                        aria-label="Sincronizar pregunta"
                      >
                        <ng-container
                          *ngIf="isSyncingQuestion[i]; else syncIconStatic"
                        >
                          <span
                            class="spinner-border spinner-border-sm"
                            role="status"
                            aria-hidden="true"
                          ></span>
                        </ng-container>
                        <ng-template #syncIconStatic>
                          <span class="material-symbols-outlined"
                            >sync_problem</span
                          >
                        </ng-template>
                      </span>
                    </button>
                  </div>
                </div>
                <div
                  class="col-sm-2 text-center rounded mx-1 col-md-1"
                  (click)="selectRadio('noAnswer-' + i)"
                >
                  <div class="pt-2">
                    <button
                      id="noAnswer-{{ i }}"
                      type="button"
                      class="btn btn-sm w-100 btn-custom-border"
                      [ngClass]="
                        questionControl.get('answer')?.value === 'No'
                          ? 'btn-primary active'
                          : 'btn-outline-primary'
                      "
                      [class.btn-sync-warning]="
                        questionControl.get('answer')?.value === 'No' &&
                        questionControl.get('isSync')?.value === false
                      "
                      (click)="$event.stopPropagation(); setAnswer(i, 'No')"
                      [attr.aria-pressed]="
                        questionControl.get('answer')?.value === 'No'
                          ? 'true'
                          : 'false'
                      "
                      [disabled]="isSubmittingAnswer[i] === 'No'"
                    >
                      <ng-container
                        *ngIf="isSubmittingAnswer[i] === 'No'; else labelNo"
                      >
                        <span
                          class="spinner-border spinner-border-sm"
                          role="status"
                          aria-hidden="true"
                        ></span>
                      </ng-container>
                      <ng-template #labelNo>No</ng-template>
                      <!-- Icono/nota inline de sincronización dentro del botón No -->
                      <span
                        class="inner-sync-icon"
                        *ngIf="
                          questionControl.get('answer')?.value === 'No' &&
                          questionControl.get('isSync')?.value === false
                        "
                        (click)="$event.stopPropagation(); onSyncQuestion(i)"
                        (mouseenter)="
                          showGlobalTooltip(
                            $event,
                            getQuestionSyncTooltipMessage(questionControl)
                          )
                        "
                        (mouseleave)="hideGlobalTooltip()"
                        [attr.title]="
                          getQuestionSyncTooltipMessage(questionControl)
                        "
                        role="button"
                        aria-label="Sincronizar pregunta"
                      >
                        <ng-container
                          *ngIf="isSyncingQuestion[i]; else syncIconStaticNo"
                        >
                          <span
                            class="spinner-border spinner-border-sm"
                            role="status"
                            aria-hidden="true"
                          ></span>
                        </ng-container>
                        <ng-template #syncIconStaticNo>
                          <span class="material-symbols-outlined"
                            >sync_problem</span
                          >
                        </ng-template>
                      </span>
                    </button>
                  </div>
                </div>
                <div class="col-sm text-end text-secondary">
                  <label
                    class="custom-file-upload pt-2 mx-1"
                    style="cursor: pointer"
                  >
                    <a
                      id="comment"
                      title="Comentario"
                      (click)="
                        onAddComment(
                          questionControl.get('comment')?.value,
                          questionControl.get('question')?.value,
                          i
                        )
                      "
                    >
                      <span
                        class="material-symbols-outlined"
                        [ngClass]="
                          getCommentClass(questionControl.get('comment')?.value)
                        "
                        >comment</span
                      >
                    </a>
                  </label>
                  <label
                    class="custom-file-upload pt-2 mx-1"
                    style="cursor: pointer"
                    *ngIf="
                      !(
                        questionHasS3Image(
                          questionControl.get('imageS3Path')?.value
                        ) ||
                        questionHasLocalImage(
                          questionControl.get('imageLocalPath')?.value
                        )
                      )
                    "
                  >
                    <input
                      type="file"
                      accept="image/*"
                      capture="environment"
                      id="image-file-{{ i }}"
                      formControlName="imageFile"
                      class="form-control"
                      (change)="onChangeImageFile($event, i)"
                    />
                    <span
                      title="Agregar Imagen"
                      class="material-symbols-outlined"
                      >photo_camera</span
                    >
                  </label>
                  <label
                    class="custom-file-upload pt-2 mx-1"
                    style="cursor: pointer"
                    *ngIf="
                      questionHasS3Image(
                        questionControl.get('imageS3Path')?.value
                      ) ||
                      questionHasLocalImage(
                        questionControl.get('imageLocalPath')?.value
                      )
                    "
                  >
                    <ng-container
                      *ngIf="
                        questionControl.get('isSyncImg')?.value === false;
                        else showImageIcon
                      "
                    >
                      <span
                        class="material-symbols-outlined sync-icon-problem"
                        (click)="onSyncQuestion(i)"
                        (mouseenter)="
                          showGlobalTooltip(
                            $event,
                            getImageSyncTooltipMessage(questionControl)
                          )
                        "
                        (mouseleave)="hideGlobalTooltip()"
                        role="button"
                        aria-label="Sincronizar imagen"
                        [attr.title]="
                          getImageSyncTooltipMessage(questionControl)
                        "
                      >
                        <!-- Si está subiendo la imagen mostramos spinner de upload -->
                        <ng-container
                          *ngIf="isUploadingImage[i]; else syncOrIconSmall"
                        >
                          <span
                            class="spinner-border spinner-border-sm"
                            role="status"
                            aria-hidden="true"
                          ></span>
                        </ng-container>
                        <ng-template #syncOrIconSmall>
                          <ng-container
                            *ngIf="isSyncingQuestion[i]; else showSyncIconSmall"
                          >
                            <span
                              class="spinner-border spinner-border-sm"
                              role="status"
                              aria-hidden="true"
                            ></span>
                          </ng-container>
                          <ng-template #showSyncIconSmall
                            ><span class="material-symbols-outlined"
                              >sync_problem</span
                            ></ng-template
                          >
                        </ng-template>
                      </span>
                    </ng-container>
                    <ng-template #showImageIcon>
                      <a
                        id="view-image"
                        title="Ver Imagen"
                        (click)="onViewImage(i)"
                      >
                        <span class="material-symbols-outlined with-content"
                          >image</span
                        >
                      </a>
                    </ng-template>
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- Progreso de respuestas -->
        <div
          class="mb-3 text-center"
          *ngIf="showFormControls && totalQuestions > 0"
        >
          <div>
            Preguntas Guardadas: {{ answeredQuestions }} de {{ totalQuestions }}
          </div>
          <div
            class="progress mt-2"
            style="height: 6px; background-color: #eee"
          >
            <div
              class="progress-bar"
              role="progressbar"
              [style.width.%]="progressPercent"
              [attr.aria-valuenow]="progressPercent"
              aria-valuemin="0"
              aria-valuemax="100"
              style="background-color: #2b8cff"
            ></div>
          </div>
        </div>
      </div>
      <div class="row mb-3">
        <div class="col-12">
          <div
            *ngIf="showFormControls"
            class="position-relative d-flex align-items-center"
            style="gap: 0.5rem"
          >
            <label
              class="custom-file-upload pt-2 me-2"
              style="cursor: pointer; z-index: 2"
            >
              <a
                id="general-comment"
                title="Comentario"
                (click)="
                  onAddGeneralComment(evaluationForm.get('comment')?.value)
                "
              >
                <span
                  class="material-symbols-outlined"
                  [ngClass]="
                    getCommentClass(evaluationForm.get('comment')?.value)
                  "
                  >comment</span
                >
              </a>
            </label>
            <div class="send-center-wrapper">
              <button
                id="evaluation-submit"
                type="button"
                class="btn btn-primary"
                (click)="
                  onSubmitEvaluation(
                    'send',
                    evaluationForm.get('comment')?.value
                  )
                "
                [disabled]="
                  !evaluationForm.valid ||
                  !allQuestionsSynced ||
                  isSubmittingEvaluation
                "
              >
                <ng-container
                  *ngIf="isSubmittingEvaluation; else normalSendLabel"
                >
                  <span
                    class="spinner-border spinner-border-sm me-2"
                    role="status"
                    aria-hidden="true"
                  ></span>
                  Enviando...
                </ng-container>
                <ng-template #normalSendLabel>Enviar evaluación</ng-template>
              </button>
            </div>
          </div>
        </div>
      </div>
    </form>
    <!-- (floating submit-success removed; full replacement message is used instead) -->
  </div>
</div>

<!-- Modal enviar/guardar evaluación-->
<ng-template #rtcSubmitModal let-c="close" let-d="dismiss">
  <div class="modal-header">
    <h4 class="modal-title" id="modal-save-send-evaluation">
      {{ modalTitle }}
    </h4>
    <button
      id="modal-save-send-evaluation-close"
      type="button"
      class="btn-close"
      aria-label="Close"
      (click)="d('Cross')"
    ></button>
  </div>
  <div class="modal-body">
    <p>
      <strong>{{ modalQuestion }}</strong>
    </p>
    <p>{{ modalMessage }}</p>

    <div class="divCenter">
      <div class="col-sm-8">
        <table class="table table-bordered text-center" style="color: black">
          <caption>
            Resumen de la Evaluación
          </caption>
          <tbody style="color: black">
            <tr>
              <th scope="row">Preguntas con Observación</th>
              <td>{{ totalComments }}</td>
            </tr>
            <tr>
              <th scope="row">Preguntas con Imágenes</th>
              <td>{{ totalImages }}</td>
            </tr>
          </tbody>
        </table>
        <form [formGroup]="commentForm">
          <div class="container-fluid">
            <div class="row">
              <div class="col-sm">
                <label for="comment" class="form-label">Observación</label>
                <div class="form-group">
                  <input
                    type="text"
                    id="comment-3"
                    formControlName="comment"
                    class="form-control immutable-field"
                    placeholder="Observación..."
                    appInputTrim
                  />
                  <div *ngIf="showHelper(commentControl.get('comment'))">
                    <small class="form-text text-muted">
                      {{ helperMessages(commentControl.get("comment")) }}
                    </small>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button
      id="modal-save-send-evaluation-cancel"
      type="button"
      class="btn btn-outline-danger"
      (click)="d('Cancel')"
    >
      Cancelar
    </button>
    <button
      id="modal-save-send-evaluation-accept"
      type="button"
      class="btn btn-outline-primary"
      (click)="c('Accept')"
    >
      Aceptar
    </button>
  </div>
</ng-template>

<!--Modal para visualizar imágenes-->
<ng-template #documentViewerModal let-c="close" let-d="dismiss">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title" id="modal-view-image">{{ modalTitle }}</h4>
        <button
          id="document-item-modal-cross"
          type="button"
          class="btn-close"
          aria-label="Close"
          (click)="d('Cross')"
        ></button>
      </div>
      <div class="modal-body">
        <div class="text-center my-5" *ngIf="isGettingURL">
          <app-spinner message="Generando Vista Previa"></app-spinner>
        </div>
        <img
          [src]="imageSource"
          (load)="imageLoaded()"
          style="max-width: 100%; max-height: 70vh"
          alt="Imagen de la pregunta"
        />
      </div>
      <div class="modal-footer" *ngIf="!isGettingURL">
        <button
          id="modal-save-send-evaluation-delete"
          type="button"
          class="btn btn-outline-danger"
          (click)="d('Delete')"
        >
          Borrar
        </button>
        <button
          id="modal-view-image-close"
          type="button"
          class="btn btn-outline-primary"
          (click)="c('Accept')"
        >
          Cerrar
        </button>
      </div>
    </div>
  </div>
</ng-template>

<!--Modal para ingresar comentarios-->
<ng-template #commentModal let-c="close" let-d="dismiss">
  <div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">{{ modalTitle }}</h4>
    <button
      id="cisterna-details-modal-close"
      type="button"
      class="btn-close"
      aria-label="Close"
      (click)="d('Cross')"
    ></button>
  </div>
  <div class="modal-body">
    <p>
      <strong>{{ modalQuestion }}</strong>
    </p>
    <p>{{ modalMessage }}</p>
    <form [formGroup]="commentForm">
      <div class="container-fluid">
        <div class="row">
          <div class="col-sm">
            <label for="comment" class="form-label">Observación</label>
            <div class="form-group">
              <input
                type="text"
                id="comment-2"
                formControlName="comment"
                class="form-control immutable-field"
                placeholder="Observación..."
                appInputTrim
              />
              <div *ngIf="showHelper(commentControl.get('comment'))">
                <small class="form-text text-muted">
                  {{ helperMessages(commentControl.get("comment")) }}
                </small>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
  <div class="modal-footer d-flex justify-content-center">
    <button
      id="cisterna-details-modal-cancel"
      type="button"
      class="btn mx-2"
      (click)="d('Cancel')"
    >
      Cancelar
    </button>
    <button
      id="cisterna-details-modal-accept"
      type="button"
      class="btn btn-outline-primary d-flex justify-content-center align-items-center rtc-chip mx-2"
      (click)="onSaveClick(c)"
      [disabled]="!commentForm.valid || isSaving"
      [class.loading]="isSaving"
      aria-live="polite"
      aria-label="Guardar evaluación"
    >
      <ng-container *ngIf="isSaving; else normalLabelGuardar">
        <span class="rtc-spinner" aria-hidden="true">
          <span class="spinner-border" role="status" aria-hidden="true"></span>
        </span>
      </ng-container>
      <ng-template #normalLabelGuardar>
        <span class="btn-text">Guardar</span>
      </ng-template>
    </button>
  </div>
</ng-template>

<!-- Modal borrar imagen-->
<ng-template #deleteImageModal let-c="close" let-d="dismiss">
  <div class="modal-header">
    <h4 class="modal-title" id="modal-delete-image">
      {{ modalTitle }}
    </h4>
    <button
      id="modal-delete-image-close"
      type="button"
      class="btn-close"
      aria-label="Close"
      (click)="d('Cross')"
    ></button>
  </div>
  <div class="modal-body">
    <p>
      <strong>{{ modalQuestion }}</strong>
    </p>
    <p>{{ modalMessage }}</p>
  </div>
  <div class="modal-footer">
    <button
      id="modal-delete-image-cancel"
      type="button"
      class="btn btn-outline-danger"
      (click)="d('Cancel')"
    >
      Cancelar
    </button>
    <button
      id="modal-delete-image-accept"
      type="button"
      class="btn btn-outline-primary"
      (click)="c('Accept')"
    >
      Aceptar
    </button>
  </div>
</ng-template>

<app-scroll-to-top></app-scroll-to-top>

<!-- Tooltip flotante global para evitar clipping con overflow -->
<div
  id="global-sync-tooltip"
  class="global-sync-tooltip"
  role="tooltip"
  aria-hidden="true"
>
  Error al cargar fotografía. Toca para reintentar
</div>
